/**
 * Настройки таблицы магазинов
 * @module PageRegularDelivery/tableConfig
 * */

export default [
  {
    title: 'Код магазина',
    field: 'external_id',
    name: 'external_id',
    sortable: true,
    filterable: true,
    columnWidth: 'width: 400px'
  },
  {
    title: 'Магазин',
    field: 'name',
    name: 'name',
    sortable: true,
    filterable: true,
    columnWidth: 'width: 400px'
  },
  {
    title: 'id формата mx',
    field: 'frmt_id',
    name: 'frmt_id',
    hidden: true,
    sortable: true,
    filterable: true,
    columnWidth: 'width: 400px'
  },
  {
    title: 'id формата mx второго уровня',
    field: 'subfrmt_id',
    name: 'subfrmt_id',
    hidden: true,
    sortable: true,
    filterable: true,
    columnWidth: 'width: 400px'
  },
  {
    title: 'формат',
    field: 'frmt',
    name: 'frmt',
    hidden: true,
    sortable: true,
    filterable: true,
    columnWidth: 'width: 400px'
  },
  {
    title: 'Наименование формата mx второго уровня',
    field: 'subfrmt',
    name: 'subfrmt',
    hidden: true,
    sortable: true,
    filterable: true,
    columnWidth: 'width: 400px'
  },
  {
    title: 'формат мм (рус)',
    field: 'format_rus',
    name: 'format_rus',
    hidden: true,
    sortable: true,
    filterable: true,
    columnWidth: 'width: 400px'
  },
  {
    title: 'Полное наименование формата mx',
    field: 'frmt_full_name',
    name: 'frmt_full_name',
    hidden: true,
    sortable: true,
    filterable: true,
    columnWidth: 'width: 400px'
  },
  {
    title: 'Дата открытия',
    field: 'open_dt',
    name: 'open_dt',
    hidden: true,
    sortable: true,
    filterable: true,
    columnWidth: 'width: 400px'
  },
  {
    title: 'Дата закрытия',
    field: 'close_dt',
    name: 'close_dt',
    hidden: true,
    sortable: true,
    filterable: true,
    columnWidth: 'width: 400px'
  },
  {
    title: 'Полное наименование',
    field: 'full_name',
    name: 'full_name',
    hidden: true,
    sortable: true,
    filterable: true,
    columnWidth: 'width: 400px'
  },
  {
    title: 'Полное наименование подразделения',
    field: 'full_division_name',
    name: 'full_division_name',
    hidden: true,
    sortable: true,
    filterable: true,
    columnWidth: 'width: 400px'
  },
  {
    title: 'Формат mm из базы статистики',
    field: 'frmt_stat',
    name: 'frmt_stat',
    hidden: true,
    sortable: true,
    filterable: true,
    columnWidth: 'width: 400px'
  },
  {
    title: 'id корпоративного региона',
    field: 'region_id',
    name: 'region_id',
    hidden: true,
    sortable: true,
    filterable: true,
    columnWidth: 'width: 400px'
  },
  {
    title: 'Регион',
    field: 'region',
    name: 'region',
    sortable: true,
    filterable: true,
    columnWidth: 'width: 400px'
  },
  {
    title: 'Федеральный регион',
    field: 'fed_region',
    name: 'fed_region',
    hidden: true,
    sortable: true,
    filterable: true,
    columnWidth: 'width: 400px'
  },
  {
    title: 'Id Корпоративного справочника городов (V_LOCATION)',
    field: 'city_id',
    name: 'city_id',
    hidden: true,
    sortable: true,
    filterable: true,
    columnWidth: 'width: 400px'
  },
  {
    title: 'Корпоративный справочник городов',
    field: 'city',
    name: 'city',
    hidden: true,
    sortable: true,
    filterable: true,
    columnWidth: 'width: 400px'
  },
  {
    title: 'Тип города/населенного пункта',
    field: 'city_type',
    name: 'city_type',
    hidden: true,
    sortable: true,
    filterable: true,
    columnWidth: 'width: 400px'
  },
  {
    title: 'Район',
    field: 'district',
    name: 'district',
    hidden: true,
    sortable: true,
    filterable: true,
    columnWidth: 'width: 400px'
  },
  {
    title: 'Адрес магазина',
    field: 'formatted_address',
    name: 'formatted_address',
    sortable: true,
    filterable: true,
    columnWidth: 'width: 400px'
  },
  {
    title: 'Действия',
    field: 'active',
    name: 'active',
    filterable: true,
    columnWidth: 'width: 400px'
  },
  {
    title: 'Временная зона (по умолчанию = 0)',
    field: 'utc',
    name: 'utc',
    hidden: true,
    sortable: true,
    filterable: true,
    columnWidth: 'width: 400px'
  },
  {
    title: 'Широта',
    field: 'latitude',
    name: 'latitude',
    hidden: true,
    sortable: true,
    filterable: true,
    columnWidth: 'width: 400px'
  },
  {
    title: 'Долгота',
    field: 'longitude',
    name: 'longitude',
    hidden: true,
    sortable: true,
    filterable: true,
    columnWidth: 'width: 400px'
  },
  {
    title: 'Guid места хранения',
    field: 'whs_guid',
    name: 'whs_guid',
    hidden: true,
    sortable: true,
    filterable: true,
    columnWidth: 'width: 400px'
  },
  {
    title: 'Время начала работы',
    field: 'work_time_begin',
    name: 'work_time_begin',
    hidden: true,
    sortable: true,
    filterable: true,
    columnWidth: 'width: 400px'
  },
  {
    title: 'Время окончания работы',
    field: 'work_time_end',
    name: 'work_time_end',
    hidden: true,
    sortable: true,
    filterable: true,
    columnWidth: 'width: 400px'
  },
  {
    title: 'Признак работающего магазина',
    field: 'working',
    name: 'working',
    hidden: true,
    sortable: true,
    filterable: true,
    columnWidth: 'width: 400px'
  },
  {
    title: 'Количество этажей',
    field: 'number_storeys',
    name: 'number_storeys',
    hidden: true,
    sortable: true,
    filterable: true,
    columnWidth: 'width: 400px'
  }
]
